import { render, staticRenderFns } from "./Tjrk.vue?vue&type=template&id=49d5fbe8&scoped=true&"
import script from "./Tjrk.vue?vue&type=script&lang=js&"
export * from "./Tjrk.vue?vue&type=script&lang=js&"
import style0 from "./Tjrk.vue?vue&type=style&index=0&id=49d5fbe8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5fbe8",
  null
  
)

export default component.exports